module.exports = __webpack_public_path__ + "img/seconde-vie.ab6d989b.svg";